import {
  removeNodeAtPath,
  changeNodeAtPath,
  defaultGetNodeKey,
  addNodeUnderParent,
  map as _mapTree
} from 'react-sortable-tree';
import { createAction } from 'redux-actions';
import _ from 'lodash';
import axios from 'axios';

import * as Urls from 'src/constants/EndpointUrls';

// Actions
export const SET_GROUP = 'GROUPS/SET_GROUP';
export const SET_TREE = 'GROUPS/SET_TREE';
export const CHANGE_TO_SHOW_MODE = 'GROUPS/CHANGE_TO_SHOW_MODE';
export const CHANGE_TO_EDIT_MODE = 'GROUPS/CHANGE_TO_EDIT_MODE';

export const EXPAND_ALL = 'GROUPS/EXPAND_ALL';
export const COLLAPSE_ALL = 'GROUPS/COLLAPSE_ALL';

export const ADD_NODE = 'GROUPS/ADD_NODE';
export const INSERT_NODE = 'GROUPS/INSERT_NODE';
export const CHANGE_VALUE = 'GROUPS/CHANGE_VALUE';
export const DELETE_NODE = 'GROUPS/DELETE_NODE';

export const UPDATE = 'GROUPS/UPDATE';
export const UPDATE_SUCCESS = 'GROUPS/UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'GROUPS/UPDATE_FAILURE';

// Action Creators
export const setGroup = createAction(SET_GROUP);
export const setTree = createAction(SET_TREE);

export const changeToShowMode = createAction(CHANGE_TO_SHOW_MODE);
export const changeToEditMode = createAction(CHANGE_TO_EDIT_MODE);

export const expandAll = createAction(EXPAND_ALL);
export const collapseAll = createAction(COLLAPSE_ALL);

export const addNone = createAction(ADD_NODE);
export const insertNode = createAction(INSERT_NODE);
export const changeNodeValue = createAction(CHANGE_VALUE);
export const deleteNode = createAction(DELETE_NODE);

export const updateList = createAction(UPDATE);
export const updateListSuccess = createAction(UPDATE_SUCCESS);
export const updateListFailure = createAction(UPDATE_FAILURE);

// Selectors
export const getTree = state => state.groups.tree;
export const getMode = state => state.groups.mode;
export const getErrors = state => state.groups.errors;

// Async Action Creators
export const updateAllGroupNodes = () => async (dispatch, getState) => {
  try {
    dispatch(updateList());
    const httpBody = {
      groups: getTree(getState())
    };
    const response = await axios.post(Urls.CREATE_CLIENT_GROUPS_URL, httpBody);
    const values = response.data.payload;
    dispatch(updateListSuccess(values.clientDepartments));
  } catch (exception) {
    dispatch(updateListFailure(exception.response.data.errors.messages));
  }
};

export const MODES = {
  SHOW: 'SHOW',
  EDIT: 'EDIT'
};

const INITIAL_STATE = {
  tree: [],
  originTree: [],
  mode: MODES.SHOW,
  errors: [],
  loading: false
};

export const mapTree = (treeData, callback) =>
  _mapTree({ treeData, getNodeKey: defaultGetNodeKey, ignoreCollapsed: false, callback });

const makeTree = groups => {
  const childrenOf = _(groups)
    .sortBy('orderNumber')
    .groupBy('parentDepartmentId')
    .value();

  const make = id => {
    const next = childrenOf[id];
    if (!next) {
      return null;
    }

    return next.map(group => {
      const children = make(group.id);

      return {
        group,
        expanded: true,
        _key: _.uniqueId(),
        children,
        canDelete: group.employeesCount === 0 && (!children || _.every(children, 'canDelete'))
      };
    });
  };
  return make('null');
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_GROUP: {
      const tree = makeTree(action.payload);

      return { ...state, tree, originTree: tree };
    }
    case SET_TREE: {
      const tree = action.payload;
      return { ...state, tree, originTree: tree };
    }
    case CHANGE_TO_SHOW_MODE:
      return { ...state, mode: MODES.SHOW, tree: state.originTree, errors: [] };
    case CHANGE_TO_EDIT_MODE:
      return { ...state, mode: MODES.EDIT };
    case UPDATE:
      return { ...state, errors: [], loading: true };
    case UPDATE_SUCCESS: {
      const tree = makeTree(action.payload);
      return { ...state, tree, originTree: tree, mode: MODES.SHOW, errors: [], loading: false };
    }
    case UPDATE_FAILURE:
      return { ...state, errors: action.payload, loading: false };
    case EXPAND_ALL:
      return { ...state, tree: mapTree(state.tree, ({ node }) => ({ ...node, expanded: true })) };
    case COLLAPSE_ALL:
      return { ...state, tree: mapTree(state.tree, ({ node }) => ({ ...node, expanded: false })) };
    case ADD_NODE: {
      const newNode = { group: { name: '', employeesCount: 0 }, expanded: true, _key: _.uniqueId(), canDelete: true };
      return { ...state, tree: [...(state.tree || []), newNode] };
    }
    case INSERT_NODE: {
      const newNode = { group: { name: '', employeesCount: 0 }, expanded: true, _key: _.uniqueId(), canDelete: true };
      return {
        ...state,
        tree: addNodeUnderParent({
          treeData: state.tree,
          newNode,
          parentKey: _.last(action.payload),
          expandParent: true,
          getNodeKey: defaultGetNodeKey
        }).treeData
      };
    }
    case CHANGE_VALUE: {
      const [path, value] = action.payload;
      return {
        ...state,
        tree: changeNodeAtPath({
          treeData: state.tree,
          path,
          getNodeKey: defaultGetNodeKey,
          newNode: ({ node }) => ({ ...node, group: { ...node.group, name: value } })
        })
      };
    }
    case DELETE_NODE:
      return {
        ...state,
        tree: removeNodeAtPath({
          treeData: state.tree,
          path: action.payload,
          getNodeKey: defaultGetNodeKey
        })
      };
    default:
      return state;
  }
};
